import * as React from 'react';
import { useMemo } from 'react';
import Layout from '../components/layout';
import { graphql } from 'gatsby';
import Img from 'gatsby-image';
import EmployerForm from '../components/forms/employerForm';

const Index = ({ data, location }) => {
  const { page } = data;
  const partners = useMemo(() => data.partners.edges.map(e => e.node), [data.partners.edges]);
  return (
    <Layout location={location} title='För arbetsgivare'
            className='flex flex-col items-stretch w-full flex-grow pt-52 pb-12 lg:pt-36 px-4 xl:px-32 space-y-24'>
      <div className='flex flex-col max-w-screen-xl mx-auto space-y-24'>
        <div
          className='flex flex-col lg:flex-row justify-center items-center lg:items-stretch lg:space-x-4 h-full pt-6 lg:pt-16'>
          <div className='col-span-2 flex flex-col space-y-8'>
            <div className='flex flex-col space-y-4'>
              <h1 className='text-4xl text-center'>{page.forEmployersTitle}</h1>
              <p className='whitespace-pre-wrap'>{page.forEmployersText.forEmployersText}
              </p>
            </div>
          </div>
          <div className='w-[2px] my-8 bg-primary' />
          <div className='flex flex-col'>
            <Img
              fixed={page.forEmployersImage1.fixed}
              alt={page.forEmployersImage1.title}
              className='rounded-xl shadow w-[320px] h-[250px]'
            />
          </div>
        </div>
      </div>
      <div
        className='bg-primary py-12 px-4 xl:px-32 -ml-4 xl:-ml-32 -mr-4 xl:-mr-32'>
        <div
          className='flex flex-col lg:flex-row lg:justify-between space-y-4 lg:space-y-0 lg:space-x-4 mx-auto max-w-screen-xl'>
          <div className='flex flex-col lg:w-1/5 p-2 rounded space-y-4 shadow bg-white'>
            <p className='text-2xl font-semibold'>{page.employersSubTitle1}</p>
            <p className='whitespace-pre-wrap'>{page.employersSubText1.employersSubText1}</p>
          </div>
          <div className='flex flex-col lg:w-1/5 p-2 rounded space-y-4 shadow bg-white'>
            <p className='text-2xl font-semibold'>{page.employersSubTitle2}</p>
            <p className='whitespace-pre-wrap'>{page.employersSubText2.employersSubText2}</p>
          </div>
          <div className='flex flex-col lg:w-1/5 p-2 rounded space-y-4 shadow bg-white'>
            <p className='text-2xl font-semibold'>{page.employersSubTitle3}</p>
            <p className='whitespace-pre-wrap'>{page.employersSubText3.employersSubText3}</p>
          </div>
          <div className='flex flex-col lg:w-1/5 p-2 rounded space-y-4 shadow bg-white'>
            <p className='text-2xl font-semibold'>{page.employersSubTitle4}</p>
            <p className='whitespace-pre-wrap'>{page.employersSubText4.employersSubText4}</p>
          </div>
        </div>
      </div>
      <div
        className='flex flex-col space-y-4 max-w-screen-md mx-auto'>
        <h1 className='text-4xl text-center'>{page.employersAdvertisementTitle}</h1>
        <p className='whitespace-pre-wrap'>{page.employersAdvertisementText.employersAdvertisementText}</p>
      </div>
      <div
        className='flex flex-col lg:flex-row space-y-12 lg:space-y-0 lg:space-x-12 justify-center items-center lg:px-24 w-full max-w-screen-xl mx-auto'>
        <div className='flex flex-col space-y-2 items-center lg:w-1/3'>
          <p className='text-2xl text-center'>Mejla oss</p>
          <a href={`mailto:${page.contactEmail}`} className='text-2xl btn-primary'>Börja
            annonsera</a>
          <p>{page.contactEmail}</p>
        </div>
        <div
          className='flex lg:h-full items-center lg:flex-col lg:space-y-2 w-full space-x-2 lg:space-x-0 lg:w-auto justify-center'>
          <div className='w-1/3 h-[2px] lg:w-[2px] lg:h-52 bg-primary' />
          <p>eller</p>
          <div className='w-1/3 h-[2px] lg:w-[2px] lg:h-52 bg-primary' />
        </div>
        <div className='flex flex-col space-y-2 lg:w-1/3'>
          <p className='text-2xl text-center'>Bli kontaktad</p>
          <EmployerForm />
        </div>
      </div>
      {partners.length > 0 && (
        <div
          className='flex flex-col space-y-8 items-center border-r-2 border-primary px-24 py-12 w-full max-w-screen-xl mx-auto mt-24'>
          <p className='text-3xl'>Ett urval av våra samarbetspartners</p>
          <div className='flex flex-col lg:flex-row space-y-4 lg:space-y-0 lg:space-x-8'>
            {partners.map(partner => (
              <a href={partner.link} key={partner.id}>
                <Img fixed={partner.image.fixed}
                     alt={partner.image.title}
                     className='rounded-xl w-[100px] h-[100px]'
                />
                <span className='sr-only'>{partner.link}</span>
              </a>
            ))}
          </div>
        </div>
      )}
    </Layout>
  );
};

export default Index;

export const query = graphql`
    query {
        page: contentfulHemsida {
            forEmployersTitle
            forEmployersText {
                forEmployersText
            }
            forEmployersImage1 {
                title
                fixed(width: 320, height: 250, quality: 90) {
                    ...GatsbyContentfulFixed_withWebp
                }
            }
            employersSubText1 {
                employersSubText1
            }
            employersSubText2 {
                employersSubText2
            }
            employersSubText3 {
                employersSubText3
            }
            employersSubText4 {
                employersSubText4
            }
            employersSubTitle1
            employersSubTitle2
            employersSubTitle3
            employersSubTitle4
            employersAdvertisementTitle
            employersAdvertisementText {
                employersAdvertisementText
            }
            contactEmail
        }
        partners: allContentfulSamarbetspartner(filter: { contentful_id: { ne: "549h9Ww1fuwdYkIlYdf9Xl" } }) {
            edges {
                node {
                    id
                    link
                    image {
                        title
                        fixed(width: 100, height: 100, quality: 90) {
                            ...GatsbyContentfulFixed_withWebp
                        }
                    }
                }
            }
        }
    }
`;